<template>
  <div class="main-panel">
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" class="logo-button" @click="goMainPanel" />
    </div>

    <header class="header">
      <div class="header__left">
        <div class="avatar" aria-hidden="true">CC</div>
        <div class="greet">
          <h1>Call Center</h1>
          <p class="sub">Monitorea desempeño de captura y productividad del equipo</p>
        </div>
      </div>
      <div class="header__right">
        <span class="hero-chip">Supervisión</span>
        <button class="btn btn--ghost" @click="goMainPanel">Regresar</button>
      </div>
    </header>

    <section class="menu-shell">
      <article
        v-if="canCaptureDashboard"
        class="menu-item menu-item--capture"
        role="link"
        tabindex="0"
        @click="go('/call-center/captura-servicios')"
        @keyup.enter="go('/call-center/captura-servicios')"
      >
        <div class="menu-item__left">
          <span class="menu-icon">📊</span>
          <div class="menu-copy">
            <h2>Captura de servicios</h2>
            <p>Vista mensual por capturista con detalle diario y acceso directo a notas.</p>
          </div>
        </div>
        <router-link class="btn btn--primary" to="/call-center/captura-servicios">Entrar</router-link>
      </article>

      <article
        class="menu-item menu-item--errors"
        role="link"
        tabindex="0"
        @click="go('/under-construction')"
        @keyup.enter="go('/under-construction')"
      >
        <div class="menu-item__left">
          <span class="menu-icon">⚠️</span>
          <div class="menu-copy">
            <h2>Errores de captura</h2>
            <p>Seguimiento de incidencias y calidad de captura (próximamente).</p>
          </div>
        </div>
        <router-link class="btn btn--primary" to="/under-construction">Entrar</router-link>
      </article>

      <article
        class="menu-item menu-item--calls"
        role="link"
        tabindex="0"
        @click="go('/under-construction')"
        @keyup.enter="go('/under-construction')"
      >
        <div class="menu-item__left">
          <span class="menu-icon">📞</span>
          <div class="menu-copy">
            <h2>Llamadas</h2>
            <p>Métricas de atención telefónica y tiempos de respuesta (próximamente).</p>
          </div>
        </div>
        <router-link class="btn btn--primary" to="/under-construction">Entrar</router-link>
      </article>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CallCenterModule',
  data() {
    return {
      permissions: [],
    }
  },
  computed: {
    canCaptureDashboard() {
      return this.hasPerm('ui_access_call_center_capture_dashboard')
    },
  },
  created() {
    this.fetchCurrentUser()
  },
  methods: {
    hasPerm(perm) {
      if (!perm) return false
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    async fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const { data } = await axios.get(`${apiDirectory}/current-user/`, {
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.permissions = data.permissions || []
        if (!this.hasPerm('ui_access_call_center_module')) {
          this.$router.push({ name: 'MainPanel' })
        }
      } catch (error) {
        this.$router.push({ name: 'MainPanel' })
      }
    },
    go(path) {
      this.$router.push(path)
    },
    goMainPanel() {
      this.$router.push({ name: 'MainPanel' })
    },
  },
}
</script>

<style scoped>
.main-panel {
  min-height: 100vh;
  background: #f3f6fd;
  padding: 12vh 24px 48px;
}
.nav-bar-operations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 10vh;
  background-color: #ffc434;
  z-index: 1000;
  display: flex;
  align-items: center;
  padding-left: 16px;
}
.logo-button { height: 55%; object-fit: contain; cursor: pointer; }
.header {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  padding: 14px 18px;
}
.header__left { display: flex; align-items: center; gap: 14px; }
.header__right { display: flex; align-items: center; gap: 8px; }
.avatar {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #ffc434, #ffe188);
  color: #3a2a00;
  font-weight: 800;
}
.greet h1 { font-size: 1.2rem; color: #0f172a; margin: 0; }
.greet .sub { margin: 2px 0 0; color: #667085; font-size: 0.92rem; }
.hero-chip {
  border-radius: 999px;
  padding: 7px 12px;
  font-size: 0.78rem;
  font-weight: 700;
  border: 1px solid rgba(2, 132, 199, 0.35);
  background: rgba(2, 132, 199, 0.1);
  color: #0c4a6e;
}
.menu-shell {
  max-width: 940px;
  margin: 16px auto 0;
  display: grid;
  gap: 12px;
}
.menu-item {
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  background: #fff;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08);
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
}
.menu-item__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.menu-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  font-size: 1.15rem;
}
.menu-item--capture .menu-icon { background: rgba(2, 132, 199, 0.14); }
.menu-item--errors .menu-icon { background: rgba(245, 158, 11, 0.18); }
.menu-item--calls .menu-icon { background: rgba(22, 163, 74, 0.16); }
.menu-copy h2 {
  margin: 0;
  color: #0f172a;
  font-size: 1rem;
}
.menu-copy p {
  margin: 3px 0 0;
  color: #475467;
  font-size: 0.9rem;
}
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid transparent;
  cursor: pointer;
  text-decoration: none;
  font-weight: 700;
}
.btn--primary { background: #2563eb; color: #fff; }
.btn--ghost { background: #fff; border-color: #d0d7de; color: #0f172a; }
</style>
